import { DefaultPagination, type Pagination } from '@bo-hooks/usePagination';
import type { Dispatch, SetStateAction } from 'react';
import type {
  MemberGroup,
  MemberGroupMember,
  MemberGroupsFilters,
  SortMemberGroupColumn
} from '@library/types/memberGroups';
import { DEFAULT_MEMBER_GROUPS_FILTERS } from '@bo-constants/memberGroups';
import { DEFAULT_MEMBER_GROUP_SORT } from '@library/constants/memberGroups';
import { createContext } from 'react';

export type MemberGroupModalTypes = 'create' | 'edit';

export type MemberGroupsContextType = {
  memberGroups?: MemberGroup[];
  isLoading: boolean;

  filters: MemberGroupsFilters;
  setFilter: (name: string, value: unknown) => void;
  resetFilters: () => void;

  currentModal?: MemberGroupModalTypes;
  modalMemberGroup?: MemberGroup;
  openModal: (modalType: MemberGroupModalTypes, id?: number) => void;
  closeModal: () => void;

  currentMemberGroup?: MemberGroup;
  setCurrentMemberGroup: (group: MemberGroup) => void;
  members?: MemberGroupMember[];
  membersPagination: Pagination;
  refetchMembers: () => void;
  refetchMemberGroups: () => void;
  isFetchingMembers?: boolean;

  setSortBy: Dispatch<SetStateAction<SortMemberGroupColumn>>;
  sortBy: SortMemberGroupColumn;
};

export const MemberGroupsContext = createContext<MemberGroupsContextType>({
  isLoading: false,

  filters: DEFAULT_MEMBER_GROUPS_FILTERS,
  setFilter: () => {},
  resetFilters: () => {},

  openModal: () => {},
  closeModal: () => {},

  setCurrentMemberGroup: () => {},
  membersPagination: DefaultPagination,
  refetchMembers: () => {},
  refetchMemberGroups: () => {},

  setSortBy: () => {},
  sortBy: DEFAULT_MEMBER_GROUP_SORT
});
